import { type FeatureModule } from '@store/features/types';
import storage from 'redux-persist/lib/storage'; // localStorage

import feedbackReducer from './slice';

/**
 * Feedback feature module definition
 */
export const feedbackFeature: FeatureModule = {
  id: 'feedback',
  name: 'Feedback',
  reducers: {
    feedback: feedbackReducer,
  },
  middleware: [],
  persistence: {
    enabled: true,
    storage: storage,
    whitelist: ['lastCSATShownTimestamp'],
  },
};
